module.exports = __webpack_public_path__ + "static/media/fb-icon.dd4a9bf5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/fb-icon.svg
// module id = 1258
// module chunks = 103